import * as React from 'react';
import {
  AlignCenterOutlined,
  AlignLeftOutlined,
  AlignRightOutlined,
} from '@ant-design/icons';
import type { ElementFormatType } from 'lexical';
import type { BlockType } from '../../utils';
import styles from '../../lexical-editor.module.css';

export const BLOCK_OPTIONS: Array<{
  label: string;
  value: BlockType;
}> = [
  { label: 'Normal', value: 'paragraph' },
  { label: 'Heading 1', value: 'h1' },
  { label: 'Heading 2', value: 'h2' },
  { label: 'Heading 3', value: 'h3' },
  { label: 'Quote', value: 'quote' },
];

export const FONT_SIZE_OPTIONS = [
  '12',
  '14',
  '16',
  '18',
  '20',
  '24',
  '28',
  '32',
];

export const DEFAULT_TEXT_COLOR = '';
export const DEFAULT_BACKGROUND_COLOR = 'transparent';

export const TEXT_COLOR_PRESETS = [
  {
    colors: [
      '#111827',
      '#ffffff',
      '#595959',
      '#cf1322',
      '#d46b08',
      '#d4b106',
      '#389e0d',
      '#08979c',
      '#0958d9',
      '#531dab',
    ],
    defaultOpen: true,
    label: 'Text colors',
  },
];

export const BACKGROUND_COLOR_PRESETS = [
  {
    colors: [
      '#ffffff',
      '#f5f5f5',
      '#fff1b8',
      '#ffd6e7',
      '#d9f7be',
      '#bae7ff',
      '#d3adf7',
      '#111827',
    ],
    defaultOpen: true,
    label: 'Highlights',
  },
];

function AlignJustifyIcon() {
  return (
    <span aria-hidden="true" className={styles.menuIcon}>
      <svg height="1em" viewBox="0 0 16 16" width="1em" fill="currentColor">
        <rect x="2" y="3" width="12" height="1.5" rx="0.75" />
        <rect x="2" y="6.5" width="12" height="1.5" rx="0.75" />
        <rect x="2" y="10" width="12" height="1.5" rx="0.75" />
        <rect x="2" y="13.5" width="12" height="1.5" rx="0.75" />
      </svg>
    </span>
  );
}

export const ALIGNMENT_OPTIONS: Array<{
  icon: React.ReactNode;
  label: string;
  value: ElementFormatType;
}> = [
  { icon: <AlignLeftOutlined />, label: 'Align left', value: 'left' },
  { icon: <AlignCenterOutlined />, label: 'Align center', value: 'center' },
  { icon: <AlignRightOutlined />, label: 'Align right', value: 'right' },
  { icon: <AlignJustifyIcon />, label: 'Justify', value: 'justify' },
];

export function isValidTableDimension(value: string, max: number) {
  const parsedValue = Number(value.trim());
  return Number.isInteger(parsedValue) && parsedValue > 0 && parsedValue <= max;
}
